import { LeafProps, ScommesseLeafItem } from './types';

import { Leaf } from '.';
import { ScommesseEsitoSkeleton } from 'components/scommesseEsitoSkeleton';
import classNames from 'classnames';
import scommesseEsitoTipoBox from 'components/scommesseEsitoTipoBox/ScommesseEsitoTipoBox.module.scss';
import scommesseListing from 'components/scommesseTipo/wrappers/scommesseListing/ScommesseListing.module.scss';
import scommesseTableQuotaSelect from 'components/scommesseTipo/components/scommesseTableQuotaSelect/ScommesseTableQuotaSelect.module.scss';
import scommesseTableQuotaSelectContainer from 'components/scommesseTipo/components/scommesseTableQuotaSelect/scommessaTableQuotaSelectContainer/ScommesseTableQuotaSelectContainer.module.scss';
import { useMemo } from 'react';
import { useIsHeaderVisible } from 'features/sport/hooks';

export interface SkeletonCellProps extends Omit<LeafProps, 'size'> {
  size?: string;
  header?: string;
  headerTrKey?: string;
}

export const SkeletonCell = (props: SkeletonCellProps) => {
  const { type, size, header, className, headerTrKey, ...oth } = props ?? {};
  const isHeaderVisible = useIsHeaderVisible();

  return useMemo(() => {
    switch (type) {
      case ScommesseLeafItem.Esito:
        return (
          <div
            className={classNames(scommesseEsitoTipoBox.container, className ?? '')}
            data-testid={`Esito-${oth.itemKey}`}
            data-kind={'betting-option'}
          >
            <button disabled className={scommesseEsitoTipoBox.wrapper}>
              <span className={scommesseEsitoTipoBox.skeletonCellHeader}>{isHeaderVisible ? header : ''}</span>
            </button>
          </div>
        );
      case ScommesseLeafItem.InfoAggiuntiva:
        return (
          <div
            className={classNames(scommesseTableQuotaSelect.singleBlock, className ?? '')}
            data-testid={`InfoAggiuntiva-${oth.infoAggiuntivaKey}`}
            data-kind={'betting-option'}
          >
            <p className={scommesseListing.paragraph}>
              <span
                className={classNames(
                  scommesseTableQuotaSelect.selectedQuota,
                  scommesseListing.label,
                  size ? scommesseTableQuotaSelectContainer[size] : ''
                )}
                suppressHydrationWarning
              >
                <Leaf type={type} {...oth} />
              </span>
            </p>
          </div>
        );
      default:
        return <ScommesseEsitoSkeleton {...props} />;
    }
  }, [oth, props, size, type]);
};
